import script from "./QModalEditAct.vue?vue&type=script&setup=true&lang=js"
export * from "./QModalEditAct.vue?vue&type=script&setup=true&lang=js"

import "./QModalEditAct.vue?vue&type=style&index=0&id=6f42e522&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f42e522"]])

export default __exports__